import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import { ReactComponent as ArrowNavBigIcon } from 'assets/images/arrow-naw-big.svg';
import { ReactComponent as ArrowNavIcon } from 'assets/images/arrow-nav.svg';
import { ReactComponent as CloseIcon } from 'assets/images/close-big-icon.svg';

import { ReactComponent as BurgerIcon } from 'assets/images/burger-icon.svg';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Header = ({ onNavClick, title, withoutMenu, sx }) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  return (
    <Box
      pt={'22px'}
      sx={{ display: 'grid', gridTemplateColumns: '37px 1fr 37px', ...sx }}
    >
      <Drawer open={open} anchor="right" onClose={() => setOpen(false)}>
        <Stack
          mt={'10%'}
          gap={3}
          sx={{ width: '90vw', p: 4, boxSizing: 'border-box' }}
        >
          <Stack direction={'row-reverse'}>
            <IconButton onClick={() => setOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            component={Link}
            to="/manageSubscriptions/privacy_policy"
          >
            <Typography>{t('accountPage.privacy_policy')}</Typography>
            <ArrowNavIcon />
          </Stack>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            component={Link}
            to="/manageSubscriptions/terms_of_use"
          >
            <Typography>{t('accountPage.terms_of_use')}</Typography>
            <ArrowNavIcon />
          </Stack>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            component={Link}
            to="/manageSubscriptions/subscription_policy"
          >
            <Typography>{t('accountPage.subscription_terms')}</Typography>
            <ArrowNavIcon />
          </Stack>
          <Stack
            direction={'row'}
            alignItems={'center'}
            justifyContent={'space-between'}
            component={Link}
            to="mailto:support@smmhub.app"
          >
            <Typography>{t('accountPage.contact_support')}</Typography>
            <ArrowNavIcon />
          </Stack>
        </Stack>
      </Drawer>
      {onNavClick ? (
        <IconButton flexShrink={0} onClick={onNavClick}>
          <ArrowNavBigIcon />
        </IconButton>
      ) : (
        <div></div>
      )}
      <Typography sx={{ alignSelf: 'center' }} variant="h1" fontSize={15}>
        {title}
      </Typography>
      {!withoutMenu ? (
        <IconButton flexShrink={0} onClick={() => setOpen(true)}>
          <BurgerIcon />
        </IconButton>
      ) : (
        <div></div>
      )}
    </Box>
  );
};
